import React from 'react';
import Scroll from '../components/Scroll';
import Map from '../components/Map';
import Hero from '../components/Hero';
import SEO from '../components/SEO';

const SiteData = {
  title: 'Kontakt',
  slug: '/kontakt',
  description: 'LUK & LUK Auto Serwis to Niezależny Serwis BMW. Jego siedziba znajduje się w Raciborzu, województwie śląskim od 2003 roku. Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów, wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe.'
};

export default ({ data }) => (
  <div>
    <SEO isSeo siteData={SiteData} type="Local Business" />
    <div className="theme-page">
      <Hero image={data.contactHero.sizes} heading="Skontaktuj się z nami">
        <div className=" margin-top-67 padding-bottom-20">
          <Scroll type="id" element="info">
            <a className="more">
              <span>zobacz dane kontaktowe</span>
            </a>
          </Scroll>
        </div>
      </Hero>
      <div className="row page-margin-top">
        <div className="column column-1-3">
          <ul className="features-list">
            <li>
              <h5>KONTAKT</h5>
              <div className="icon sl-small-phone-circle" />
              <p>
                Biuro: <a href="tel:+48 793 700 098">+48 793 700 098</a>
                <br />
                E-mail: <a href="mailto:bmw.luk@op.pl">bmw.luk@op.pl</a>
              </p>
            </li>
          </ul>
        </div>
        <div className="column column-1-3" id="info">
          <ul className="features-list">
            <li>
              <h5>BIURO</h5>
              <div className="icon sl-small-location-map" />
              <p>
                Huzarska 12<br />
                47-400 Racibórz<br />
              </p>
            </li>
          </ul>
        </div>
        <div className="column column-1-3">
          <ul className="features-list">
            <li>
              <h5>POMOC DROGOWA</h5>
              <div className="icon sl-small-truck-tow" />
              <p>
                Telefon: <a href="tel:+48 728 913 865">+48 728 913 865</a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className="clearfix" id="map">
        {/* <div className="row  padding-top-70 padding-bottom-66">
        <div className="row">
          <div className="column column-1-1">
            <div className="row">
              <h2 className="box-header">Możesz nas odwiedzić</h2>
              <p className="description align-center">w naszej siedzibie w Raciborzu</p>
            </div>
          </div>
        </div>
      </div> */}
        <div className="row full-width padding-top-70">
          <Map
            isMarkerShown
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDIKeMfh0L55ulBV3GcDFWcd7j0fu0rOT4&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `500px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            title="Luk & Luk s.c. Auto Serwis"
            address="Huzarska 12, <br />47-400 Racibórz"
          />
        </div>
      </div>
    </div>
  </div>
);

export const query = graphql`
  query ContactPage {
    contactHero: imageSharp(id: { regex: "/contactHero/" }) {
      sizes(maxWidth: 1900, maxHeight: 900) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/kontakt.js